export default __webpack_public_path__ + "static/media/place.7803a190.svg";